import Panel from '../../../common/layout/Panel'
import DataResource from '../../../common/v4/DataResource';

const MailAccountsList = (props) => {
    const data = {
        url: '/admin/mail-accounts',
        data: {
            data: [],
            metadata: []
        },
        userFilterExpandable: true,
        onclick: 'link',
        link: '/settings/mail_accounts/{id}',
        metadata: [
            { source: 'id', label: 'ID', type: 'primary', editable: false, visible: false },
            { source: 'name', label: 'Name', type: 'text' },
            { source: 'email', label: 'Email', type: 'text' },
            { source: 'provider', label: 'Provider', type: 'text' },
            { source: 'smtp_enabled', label: 'SMTP', type: 'boolean' },
            { source: 'imap_enabled', label: 'IMAP', type: 'boolean' },
            { source: 'is_active', label: 'Active', type: 'boolean' },
            { type: 'delete', label: 'Delete' }
        ]
    }
    return (
       <Panel title = "Mail Accounts">
            <DataResource
                addButtonText = "Create Mail Account"
                addButtonLink = "/settings/mail_accounts/create"                    
                data = {data}
                {...props}
            />
        </Panel>
    )
}

export default MailAccountsList;
